import React from 'react';
import styled from 'styled-components';
import { string, arrayOf, shape } from 'prop-types';
import { C_SHADOW } from '@bbc/psammead-styles/colours';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_0_SCREEN_WIDTH_MAX, GEL_GROUP_1_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MAX, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { grid } from '@bbc/psammead-styles/detection';
import Link from '../Link'; // Gets the number of grid rows, taking into account the
// trustProjectLink in the grid being separate, on its own row.

var getRowCount = function getRowCount(links, columns, trustProjectLink) {
  return trustProjectLink ? Math.ceil(links.length / columns) + 1 : Math.ceil(links.length / columns);
};

var StyledList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledList",
  componentId: "sc-2e1ekc-0"
})(["border-bottom:0.0625rem solid ", ";list-style-type:none;margin:0;padding:", ";column-count:4;@supports (", "){display:grid;grid-auto-flow:column;}@media (max-width:", "){grid-auto-flow:row;column-count:1;}@media (min-width:", ") and (max-width:", "){grid-column-gap:", ";grid-template-columns:repeat(2,1fr);grid-template-rows:repeat( ", ",auto );column-count:2;}@media (min-width:", ") and (max-width:", "){grid-column-gap:", ";grid-template-columns:repeat(3,1fr);grid-template-rows:repeat( ", ",auto );column-count:3;}@media (min-width:", ") and (max-width:", "){grid-column-gap:", ";grid-template-columns:repeat(4,1fr);grid-template-rows:repeat( ", ",auto );column-count:4;}@media (min-width:", "){grid-column-gap:", ";grid-template-columns:repeat(5,1fr);grid-template-rows:repeat( ", ",auto );column-count:5;}", ""], C_SHADOW, function (_ref) {
  var trustProjectLink = _ref.trustProjectLink;
  return trustProjectLink ? "0 0 ".concat(GEL_SPACING) : "".concat(GEL_SPACING, " 0");
}, grid, GEL_GROUP_0_SCREEN_WIDTH_MAX, GEL_GROUP_1_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_SPACING, function (_ref2) {
  var links = _ref2.links,
      trustProjectLink = _ref2.trustProjectLink;
  return getRowCount(links, 2, trustProjectLink);
}, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_SPACING_DBL, function (_ref3) {
  var links = _ref3.links,
      trustProjectLink = _ref3.trustProjectLink;
  return getRowCount(links, 3, trustProjectLink);
}, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MAX, GEL_SPACING_DBL, function (_ref4) {
  var links = _ref4.links,
      trustProjectLink = _ref4.trustProjectLink;
  return getRowCount(links, 4, trustProjectLink);
}, GEL_GROUP_5_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, function (_ref5) {
  var links = _ref5.links,
      trustProjectLink = _ref5.trustProjectLink;
  return getRowCount(links, 5, trustProjectLink);
}, function (_ref6) {
  var trustProjectLink = _ref6.trustProjectLink;
  return trustProjectLink && "> li:first-child {\n    border-bottom: 0.0625rem solid ".concat(C_SHADOW, ";\n    padding: ").concat(GEL_SPACING, " 0;\n    margin-bottom: ").concat(GEL_SPACING, ";\n    grid-column: 1/-1;\n    width: 100%;\n    column-span: all;\n  }");
});
var StyledListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledListItem",
  componentId: "sc-2e1ekc-1"
})(["min-width:50%;column-gap:", ";break-inside:avoid-column;"], GEL_SPACING_DBL);

var listItem = function listItem(key, text, href, lang) {
  return /*#__PURE__*/React.createElement(StyledListItem, {
    key: key,
    role: "listitem"
  }, /*#__PURE__*/React.createElement(Link, {
    text: text,
    href: href,
    lang: lang
  }));
};

var List = function List(_ref7) {
  var links = _ref7.links,
      trustProjectLink = _ref7.trustProjectLink;
  return /*#__PURE__*/React.createElement(StyledList, {
    role: "list",
    trustProjectLink: trustProjectLink,
    links: links
  }, trustProjectLink && listItem(trustProjectLink.text, trustProjectLink.text, trustProjectLink.href), links.map(function (link) {
    return listItem(link.text, link.text, link.href, link.lang);
  }));
};

var linkPropTypes = shape({
  href: string.isRequired,
  text: string.isRequired,
  lang: string
});
List.propTypes = {
  links: arrayOf(linkPropTypes.isRequired).isRequired,
  trustProjectLink: linkPropTypes
};
List.defaultProps = {
  trustProjectLink: null
};
export default List;